import { socketEventNames } from './helper';

const { GET_ZOOM_CALIBRATION } = socketEventNames;
const DEFAULT_TIMEOUT_MS = 8000;

/**
 * Ask connected ACS for pan/tilt step sizes at a zoom level (ACS CAMERA_ZOOM_CALIBRATION).
 * @returns {Promise<{ panStep: number, tiltStep: number, model: string, zoom: number }>}
 */
export const fetchZoomCalibration = (
  socket,
  camera,
  zoom,
  { timeoutMs = DEFAULT_TIMEOUT_MS } = {},
) => {
  if (!socket) {
    return Promise.reject(new Error('Socket is not connected.'));
  }
  if (!camera) {
    return Promise.reject(new Error('No camera selected.'));
  }

  const z = Number(zoom);

  return new Promise((resolve, reject) => {
    let settled = false;
    let timeoutId;

    const finish = (fn, value) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      fn(value);
    };

    timeoutId = setTimeout(() => {
      finish(reject, new Error('zoom_calibration_timeout'));
    }, timeoutMs);

    socket.emit(GET_ZOOM_CALIBRATION, 'host', camera, { zoom: z }, (result = {}) => {
      if (result.ok === false || result.error) {
        finish(reject, new Error(result.error || 'Zoom calibration failed.'));
        return;
      }
      const panStep = Number(result.panStep);
      const tiltStep = Number(result.tiltStep);
      if (!Number.isFinite(panStep) || !Number.isFinite(tiltStep) || !panStep || !tiltStep) {
        finish(reject, new Error('ACS returned invalid zoom calibration steps.'));
        return;
      }
      finish(resolve, {
        panStep,
        tiltStep,
        model: result.model || null,
        zoom: Number(result.zoom) || z,
      });
    });
  });
};

export default fetchZoomCalibration;
